// @ts-expect-error Untyped dependency
import EditReportButton from 'reporting-action-components/reportingActions/editReport/EditReportButton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ActionCustomizeReport({
  report
}) {
  return /*#__PURE__*/_jsx(EditReportButton, {
    report: report
  });
}